import { useEffect } from "react";
import { UserManagementLayout } from "./style";
import { UserTable } from "./components/usersTable/UserTable";
import { Outlet, useLocation } from "react-router-dom";
import { useAppDispatch } from "../../store/config";
import { resetUsers } from "../../store/features/users/users-slice";

export const Users = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetUsers());
    };
  }, []);

  return (
    <UserManagementLayout>
      {location.pathname === "/users" && <UserTable />}
      <Outlet />
    </UserManagementLayout>
  );
};
